import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { OrganizationsEffects } from './organizations.effects';
import { organizationsReducer } from './organizations.reducer';
import { ORGANIZATIONS_FEATURE_KEY } from './organizations.reducer';
import { OrganizationsFacade } from './organizations.facade';
import { OrganizationsService } from './organizations.service';

@NgModule({
    imports: [
        CommonModule,
        StoreModule.forFeature(ORGANIZATIONS_FEATURE_KEY, organizationsReducer),
        EffectsModule.forFeature([OrganizationsEffects])
    ],
    providers: [OrganizationsService, OrganizationsFacade],
    declarations: [],
    exports: []
})
export class OrganizationsModule {}
